import { css } from "@emotion/css";
import { findUISchema, Generate } from "@jsonforms/core";
import { JsonFormsDispatch } from "@jsonforms/react";
import { useContext, useMemo } from "react";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { Text } from "../components/Text";
import { withCascadiaControlProps } from "../wrappers/withCascadiaControlProps";

export const ObjectRenderer = withCascadiaControlProps((props) => {
  const { isCheckResults } = useContext(CascadiaJsonFormContext);

  const detailUiSchema = useMemo(() => {
    return findUISchema([], props.schema, props.uischema.scope, props.path);
  }, [props.schema, props.uischema.scope, props.path]);

  // This is a workaround for using the auto-generated uiSchemas jsonforms provides. We
  // use allOf rules in our data schemas and when these are present the uiSchema
  // generator gets stuck in an infinite loop of deciding the uiSchema is a control with
  // a '#' scope, eventually crashing the page. While the basic check results doesn't
  // support a custom uiSchema we can auto-generate the uiSchema but without the allOf
  // rules for it to work.
  //
  // Additionally, Generate.uiSchema() cannot handle array types like ["object", "null"].
  // We normalize these to their non-null type before generating the uiSchema.
  const autoGeneratedUiSchemaWithoutAllOf = useMemo(() => {
    const { allOf, ...rest } = props.schema;
    if (Array.isArray(rest.type)) {
      rest.type = rest.type.find((t) => t !== "null") ?? "object";
    }
    return Generate.uiSchema(rest);
  }, [props.schema]);

  const uiSchema = isCheckResults
    ? autoGeneratedUiSchemaWithoutAllOf
    : detailUiSchema;

  const options = props.uischema.options || {};
  const description = options.description || props.description;

  return (
    <div hidden={!props.visible} className={styles.object}>
      {props.label && <Text style="form/section-heading">{props.label}</Text>}
      <JsonFormsDispatch
        visible={props.visible}
        enabled={props.enabled}
        schema={props.schema}
        uischema={uiSchema}
        path={props.path}
        renderers={props.renderers}
        cells={props.cells}
      />
      <Text style="input/helper" color="text-weak">
        {description}
      </Text>
    </div>
  );
});

const styles = {
  object: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
};
